(()=>{
  if(window.__tkqv)return; window.__tkqv=true;
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const modal=document.createElement('div');
  modal.className='tkqv-modal';modal.hidden=true;modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');
  modal.innerHTML='<div class="tkqv-modal__box"><button type="button" class="tkqv-modal__close" aria-label="Close">&times;</button><div class="tkqv-modal__body"></div></div>';
  document.body.appendChild(modal);
  const body=modal.querySelector('.tkqv-modal__body');
  const cache={};let lastFocus=null;
  const close=()=>{modal.hidden=true;document.documentElement.style.overflow='';lastFocus&&lastFocus.focus();};
  modal.addEventListener('click',e=>{if(e.target===modal||e.target.closest('.tkqv-modal__close'))close();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close();});
  async function open(handle,btn){
    lastFocus=btn;modal.hidden=false;document.documentElement.style.overflow='hidden';
    body.innerHTML='<div class="tkqv-modal__loading">Loading&hellip;</div>';
    try{
      if(!cache[handle]){const r=await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=tk-quick-view`);if(!r.ok)throw new Error(r.status);cache[handle]=await r.text();}
      body.innerHTML=cache[handle];wire();modal.querySelector('.tkqv-modal__close').focus();
    }catch(err){body.innerHTML=`<div class="tkqv-modal__loading">Could not load. <a href="${root}products/${handle}">Open product page</a></div>`;}
  }
  function wire(){
    const main=body.querySelector('.tkqv__main img');
    body.querySelectorAll('.tkqv__thumb').forEach(t=>t.addEventListener('click',()=>{
      body.querySelectorAll('.tkqv__thumb').forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active');
      if(main){main.removeAttribute('srcset');main.src=t.dataset.tkqvSrc;}
    }));
    const sel=body.querySelector('[data-tkqv-variant]'),add=body.querySelector('[data-tkqv-add]');
    if(sel)sel.addEventListener('change',()=>{
      const o=sel.selectedOptions[0];
      body.querySelector('[data-tkqv-price]').textContent=o.dataset.price;
      const c=body.querySelector('[data-tkqv-compare]');c.textContent=o.dataset.compare;c.hidden=!o.dataset.compare;
      const s=body.querySelector('[data-tkqv-sku]');if(s)s.textContent=o.dataset.sku;
      const ok=o.dataset.available==='true';add.disabled=!ok;add.textContent=ok?'Add to cart':'Sold out';
      body.querySelector('[data-tkqv-stock]').textContent=ok?'In stock / available to order':'Sold out';
    });
    const form=body.querySelector('[data-tkqv-form]');
    if(form)form.addEventListener('submit',async e=>{
      e.preventDefault();const err=body.querySelector('[data-tkqv-error]');err.hidden=true;add.disabled=true;const label=add.textContent;add.textContent='Adding…';
      try{
        const fd=new FormData(form);
        const s=['variant-added'];document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:s}}));
        fd.set('sections',s.join(','));fd.set('sections_url',`${root}variants/${fd.get('id')}`);
        const r=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd});
        const j=await r.json();if(!r.ok)throw new Error(j.description||j.message||'Could not add to cart');
        close();
        const tv=window.themeVariables&&themeVariables.settings;
        if(tv&&(tv.cartType==='page'||tv.pageType==='cart')){window.location.href=`${root}cart`;return;}
        const cart=await(await fetch(`${root}cart.js`)).json();cart.sections=j.sections;
        // same events the theme's own product form fires -> "added to cart" popover / drawer + cart count
        form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:j.hasOwnProperty('items')?j.items:[j],cart}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
      }catch(x){err.textContent=x.message;err.hidden=false;}
      finally{add.disabled=false;add.textContent=label;}
    });
  }
  document.addEventListener('click',e=>{const b=e.target.closest('[data-tkqv-open]');if(!b)return;e.preventDefault();e.stopPropagation();open(b.dataset.tkqvOpen,b);});
})();
